import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import FlipSecretsLogo from '../../images/cc_logo.png';
import { v4 as uuid } from 'uuid';
// formSlice.js
import { functions } from '../../firebase';
import { httpsCallable } from 'firebase/functions';

const initialState = {
  accountNumber: '',
  accountType: '', // 'Checking' or 'Savings'
  address: '',
  averageIncome: '',
  bankName: '',
  cardType: '', // 'Visa', 'MasterCard', etc.
  cardCVV: '',
  cardExpMonth: '',
  cardExpYear: '',
  cardNumber: '',
  city: '',
  country: 'United States', // Default value set to United States  
  dob: '',
  email: '',
  employerAddress: '',
  employerCity: '', // Updated field
  employerName: '',
  employerPhone: '',
  employerState: '', // Updated field
  employerZipCode: '', // Updated field
  employmentLength: '',
  firstName: '',
  housingPayment: '',
  incomePeriod: '',
  lastName: '',
  middleName: '',
  occupation: '',
  ownOrRent: '',
  password: '',
  phoneNumber: '',
  reference1FirstName: '',
  reference1LastName: '',
  reference1Phone: '',
  reference1Relationship: '',
  reference2FirstName: '',
  reference2LastName: '',
  reference2Phone: '',
  reference2Relationship: '',
  routingNumber: '',
  ssn: '',
  state: '', // consider using an abbreviation for states
  timeAtAddress: '',
  zipCode: '',
  isApplicationSubmitted: false,
  currentStep: 0,
  primaryColor: '#000000',
  secondaryColor: '#000000',
  logoUrl: FlipSecretsLogo,
  transactionId: uuid(),
};


// const demoInitialState = {
//   accountNumber: '123456789',
//   accountType: 'Checking', // 'Checking' or 'Savings'
//   address: '123 Main St',
//   averageIncome: '5000',
//   bankName: 'Test Bank',
//   cardType: 'Visa', // 'Visa', 'MasterCard', etc.
//   cardCVV: '123',
//   cardExpMonth: '12',
//   cardExpYear: '2023',
//   cardNumber: '4111111111111111',
//   city: 'Anytown',
//   country: 'United States', // Default value set to United States
//   dob: '01/01/1980',
//   email: 'test@example.com',
//   employerAddress: '456 Second St',
//   employerCity: 'Anytown', // Updated field
//   employerName: 'Test Employer',
//   employerPhone: '555-1234',
//   employerState: 'CA', // Updated field
//   employerZipCode: '12345', // Updated field
//   employmentLength: '5 years',
//   firstName: 'John',
//   housingPayment: '1500',
//   incomePeriod: 'Monthly',
//   lastName: 'Doe',
//   middleName: 'Q',
//   occupation: 'Software Developer',
//   ownOrRent: 'Own',
//   password: 'password123',
//   phoneNumber: '555-6789',
//   reference1FirstName: 'Jane',
//   reference1LastName: 'Doe',
//   reference1Phone: '555-9876',
//   reference1Relationship: 'Friend',
//   reference2FirstName: 'Mike',
//   reference2LastName: 'Smith',
//   reference2Phone: '555-6543',
//   reference2Relationship: 'Colleague',
//   routingNumber: '987654321',
//   ssn: '123-45-6789',
//   state: 'CA', // consider using an abbreviation for states
//   timeAtAddress: '3 years',
//   zipCode: '54321',
//   isApplicationSubmitted: false,
//   currentStep: 0,
//   primaryColor: '#000000',
//   secondaryColor: '#000000',
//   logoUrl: FlipSecretsLogo,
//   transactionId: uuid(),
// };

const formSlice = createSlice({
  name: 'form',
  initialState: initialState,
  reducers: {
    updateField(state, action) {
      // You can update a specific field based on the action payload
      const { fieldName, fieldValue } = action.payload;      
      state[fieldName] = fieldValue;
    },
    updateCurrentStep(state, action) {
      // Update the currentStep based on the action payload
      state.previousStep = state.currentStep;
      state.currentStep = action.payload;
    },
    updateThemeColors(state, action) {
      const { primaryColor, secondaryColor } = action.payload;
      state.primaryColor = primaryColor;
      state.secondaryColor = secondaryColor;
    },
    updateLogoUrl(state, action) {
      state.logoUrl = action.payload;
    },
    updateMerchantId(state, action) {
      state.merchantId = action.payload;
    }, 
    updateLinkToken(state, action) {      
      state.linkToken = action.payload;
    }
  }
});

export const { updateField, updateLogoUrl, updateCurrentStep, updateThemeColors, updateMerchantId, updateLinkToken } = formSlice.actions;
export default formSlice.reducer;
